import React, { useMemo } from "react";

import { type NostoContextProps } from "~/providers/NostoProvider";
import { useRouteLoaderData } from "~/hooks/useRouteLoaderData";

import { MultiBox } from "@bared/ui";

type SizeType = {
  _key: string;
  bared: string;
  us_au: string;
  cm: string;
  inch: string;
};

type FacetSectionBoxProps = {
  data: { value: string; count: number; selected: boolean }[];
  gender: NostoContextProps["gender"];
  handleChange: (value: string) => void;
  field: string;
  selectedFilters: NostoContextProps["selectedFilters"];
};
export const FacetSectionBox = ({
  data,
  gender,
  handleChange,
  field,
  selectedFilters,
}: FacetSectionBoxProps) => {
  const { sizeGuide } = useRouteLoaderData("routes/$site");

  const convertedSizing: SizeType[] = useMemo(() => {
    if (gender === "men") {
      return [...sizeGuide.men];
    } else {
      return [...sizeGuide.women];
    }
  }, [gender, sizeGuide]);

  // Safety check: return null if data is not available
  if (!data || data.length === 0) {
    return null;
  }

  // Get the selected values for this field from selectedFilters
  const selectedValues =
    selectedFilters.find((filter) => filter.field === field)?.value ?? [];

  const mappedOptions = data.map(({ value, count }) => {
    const us_size = convertedSizing.find((size) => size.bared === value)?.us_au;

    return {
      label: value,
      count,
      checked: selectedValues.includes(value),
      us_size,
    };
  });

  return <MultiBox options={mappedOptions} handleChange={handleChange} />;
};
